import React from 'react';
import {Link} from 'react-router-dom';
import {withTranslation} from 'react-i18next';

import _adviserPortalHome from './_adviserPortalHome';

function TotalMembers(props){
    const {t} = props;
    const totalMembersDetails =  _adviserPortalHome._totalMembersInDetail(props)
    return( 
        <div id='adviser-data-members'>
            <div>
                <Link className="adviserLoginDataLink link" to="/adv/totalMembers">        
                    <div className="adviserDataMembers">{totalMembersDetails.totalMembers}</div>{t('Members:totalMembers')}
                </Link>
            </div>
            {
                totalMembersDetails.productMembers.map((members, index) => 
                    <div key={index}>
                        <Link className="adviserLoginDataLink link" to={`/adv/totalMembers/${members.code}`}>
                            <div className="adviserDataMembers">{members.members}</div>{members.name}
                        </Link>
                    </div>    
                )
            }
        {/* <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLKS">
            <div className="adviserDataMembers">{totalMembersDetails.kiwiSaver}</div>{t('Members:slksMembers')}
        </Link></div>
        <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLI">
            <div className="adviserDataMembers">{totalMembersDetails.invest}</div>{t('Members:sliMembers')}
        </Link></div>
        <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLUK">
            <div className="adviserDataMembers">{totalMembersDetails.ukPension[0] ? 
                totalMembersDetails.ukPension[0].length === 0 ? 0 
                : totalMembersDetails.ukPension : 0}</div>{t('Members:slukMembers')}
        </Link></div> */}
    </div>

    // <div style={{marginLeft: "auto", marginRight: "auto", paddingTop: "10px"}}>
    //     <Table className="adviserLogin">
    //             <tr>
    //                 <th><Link className="adviserLoginLink link" to="/adv/totalMembers">{t('total')+" "+t('member')+'s'}</Link></th>
    //                 <td style={{color: "white", fontSize: "16px"}}>{totalMembersDetails.totalMembers}</td>
    //             </tr>
    //     </Table>
    //     <Table className="adviserLogin adviserLoginData">
    //         <tr>
    //             <th><Link className="adviserLoginDateLink link" to="/adv/totalMembers/SLKS">{t('kiwiSaver')}</Link></th>
    //             <td style={{color: "#333333", fontSize: "16px"}}>{totalMembersDetails.kiwiSaver}</td>

    //         </tr>
    //         <tr>
    //             <th><Link className="adviserLoginDateLink link" to="/adv/totalMembers/SLI">{t('invest')} </Link></th>
    //             <td style={{color: "#333333", fontSize: "16px"}}>{totalMembersDetails.invest}</td>

    //         </tr>
    //         <tr>
    //             <th><Link className="adviserLoginDateLink link" to="/adv/totalMembers/SLUK">{t('ukPension')} </Link></th>  
    //             <td style={{color: "#333333", fontSize: "16px"}}>{totalMembersDetails.ukPension[0] ? 
    //                 totalMembersDetails.ukPension[0].length ===0 ? 0 : totalMembersDetails.ukPension : 0}</td>

    //         </tr>   
    //     </Table>
    // </div>
    );

    
   
        
    
}



export default withTranslation()(TotalMembers);